import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface DeleteInvestmentFilePayload {
  investmentUuid: string;
  fileUuid: string;
}

export const useDeleteInvestmentFile = (
  options?: UseMutationOptions<any, Error, DeleteInvestmentFilePayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["deleteInvestmentFile"],
    mutationFn: async (data: DeleteInvestmentFilePayload) => {
      return axiosInstance
        .delete(`/investments/${data.investmentUuid}/files/${data.fileUuid}`)
        .then((res) => res.data);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas usuwania pliku.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "delete-investment-file",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
